module.exports = __webpack_public_path__ + "static/media/35_A.ce809b10.png";